import type { FEATURE_TYPES } from 'constants/features';
import type { RootState } from 'reducers/types';

type Features = (typeof FEATURE_TYPES)[number];

export const getFeatures = (state: RootState) => {
  const { features = {} } = state;

  return features;
};

export const getFeature = (state: RootState, feature: Features): boolean => {
  const features = getFeatures(state);

  return Object.hasOwn(features, feature) ? !!features[feature] : false;
};
